
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({
    name: 'ROSwitch',
})
export default class ROSwitch extends Vue {
    /** 数据 */
    @Prop({ type: Boolean, default: false }) public value!: boolean;
    /** key */
    @Prop({ type: String, default: '' }) public switchKey?: string;

    public on: boolean = false;

    @Watch('$props.value')
    public onPropValueChange(val: boolean) {
        this.on = val;
    }
    @Watch('on')
    public onOnChange(val: boolean) {
        this.$emit('input', val);
    }

    public onClick() {
        this.$emit('click', !this.on, this.switchKey);
    }

    public created() {
        this.on = this.value;
    }
}
